import { MUTE_MEETING_AUDIO } from '../Types';

function muteMeetingAudio(muteMeetingAudio) {
  return dispatch => {
    const action = {
      type: MUTE_MEETING_AUDIO,
      payload: muteMeetingAudio
    };

    dispatch(action);
  };
}

export default muteMeetingAudio;
